import { LicenseManager } from 'ag-grid-enterprise';
import { logger } from 'src/logger';
import { SSMService } from 'src/services/aws/SSMService';

const AG_GRID_LICENSE_STORAGE_KEY = 'ag-grid-license-key';

export class AgGridLicenseService {
  private static readonly AgGridLicenseKeyParameterStoreKey = '/das-finsuite/fe/ag-grid-license';

  /** Synchronously apply a cached license key if available. Called at bootstrap before any grid renders. */
  public static applyCachedLicense(): void {
    try {
      const cached = sessionStorage.getItem(AG_GRID_LICENSE_STORAGE_KEY);
      if (cached) {
        LicenseManager.setLicenseKey(cached);
      }
    } catch {
      // Best-effort: sessionStorage may be unavailable (private mode, disabled, etc.).
    }
  }

  /** Async fetch from SSM, cache in sessionStorage, and apply. */
  public static async configureLicense(): Promise<string> {
    const licenseKey = await SSMService.retrieveParameter(this.AgGridLicenseKeyParameterStoreKey);
    if (licenseKey) {
      LicenseManager.setLicenseKey(licenseKey);
      try {
        sessionStorage.setItem(AG_GRID_LICENSE_STORAGE_KEY, licenseKey);
      } catch {
        // Caching is best-effort; license is already applied above.
      }
      logger.info('Ag-Grid License configured successfully!', { logType: 'configStatus' });
      return 'setLicenseKey_Success';
    } else {
      logger.error('Ag-Grid License setup failed!', { logType: 'configStatus' });
      throw new Error('setLicenseKey_Failed');
    }
  }
}
